import React from 'react';
import {Bar, BarChart as BChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const BarChart = (props) => {

  const {
    data,
    vertical,
    colors = [],
    tickFormatter = v=>v,
    labelFormatter = v=>v,
    showX = true,
    showY = true,
    showToolTip = true
  } = props;

  const inputs = data.map(d => {
    return {
      key: d.key,
      label: (d.label || d.key).slice(0, 24),
      value: d.value,
      barLabel: d.barLabel || '',
      toolTip: d.toolTip || ''
    };
  });

  const xAxis = vertical ?
    <XAxis type="number" hide={!showX} tickFormatter={tickFormatter}/> :
    <XAxis dataKey="label" type="category" hide={!showX} tickFormatter={tickFormatter}/>;

  const yAxis = vertical ?
    <YAxis dataKey="label" type="category" hide={!showY} style={{fontSize:12}} />:
    <YAxis type="number" hide={!showY}/>;

  const cells = inputs.map((entry, index) => {
    return <Cell
      key={`cell-${index}`}
      fill={colors[entry.key] || '#212121'}
      label={false}
    />;
  });

  const BarTooltip = ({active, payload}) => {
    if (active && payload && payload.length) {
      return (
        <div className="bar-tooltip">
          <p className="label">{payload[0].payload.label}</p>
          <p className="value">{payload[0].payload.toolTip}</p>
        </div>
      );
    }
    return null;
  };

  const renderLabelVertical = props => {
    const wide = (props.height||0) * 4 < (props.width||0);
    const textAnchor = wide ? 'end' : 'start';
    const xPos = (props.x||0) + (props.width||0) + ( wide ? - 5 : 5 );
    const yPos = (props.y||0) + (props.height||0) / 2;
    const fontSize = (props.height||0)*3/5;
    return <text x={xPos} y={yPos} style={{fontSize,textAnchor}} textAnchor="middle" dominantBaseline="middle">{ labelFormatter(props.value) }</text>;
  };

  //TODO: render horizontal labels
  const renderLabelHorizontal = props => {
    return <text>{ labelFormatter(props.value) }</text>;
  };

  return (
    <ResponsiveContainer>
      <BChart data={inputs} margin={{top: 0, right: 0, left: 0, bottom: 0}} layout={vertical ? 'vertical' : 'horizontal'}>
        {xAxis}
        {yAxis}
        <Bar dataKey="value" isAnimationActive={false} label={vertical ? renderLabelVertical : renderLabelHorizontal }>
          {cells}
        </Bar>
        { showToolTip ? <Tooltip content={<BarTooltip/>} cursor={false}/> : null }
      </BChart>
    </ResponsiveContainer>
  );
};

export default BarChart;
